/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import img from 'common/images/zonifero_logo_black.svg';
import PropTypes from 'prop-types';
import ANCHOR from 'common/consts/anchor';
import { inject, observer } from 'mobx-react';
import { scrollTo } from 'animations/Animations';
import LogoWrapper from './LogoWrapper';
import LogoImage from './LogoImage';
import LanguageLink from '../../../elements/LanguageLink';

@inject('navigationStore', 'windowStore', 'appStore')
@observer
class Logo extends Component {
  render() {
    const {
      fixed,
      absolute,
      backgroundColor,
      alignSelf,
      big,
      navigationStore,
      windowStore,
      appStore: {
        currentLanguage,
      },
    } = this.props;

    return (
      <LogoWrapper
        fixed={fixed}
        absolute={absolute}
        backgroundColor={backgroundColor}
        alignSelf={alignSelf}
      >
        <LanguageLink
          to={ANCHOR.HOME[currentLanguage]}
          onClick={() => {
            navigationStore.closeMobileNav();
            scrollTo(0, 0);
          }}
        >
          <LogoImage
            big={big}
            src={windowStore.adjustImageSize(img)}
          />
        </LanguageLink>
      </LogoWrapper>
    );
  }
}
Logo.propTypes = {
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  backgroundColor: PropTypes.string,
  alignSelf: PropTypes.string,
  big: PropTypes.bool,
};
Logo.defaultProps = {
  fixed: false,
  absolute: false,
  backgroundColor: '',
  alignSelf: '',
  big: false,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Logo/index.jsx